import {Component, inject, OnInit} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ViewService} from '../../../shared/service/view.service';
import {PlayerAuthenticationService} from '../../service/player-authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PLAYER_PREFIX_FULL} from '../../player.routes';
import {Panel} from 'primeng/panel';
import {ReactiveFormsModule} from '@angular/forms';
import {
  PlayerProfileRegisterFormComponent
} from './player-profile-register-form/player-profile-register-form.component';
import {PlayerProfileLoginFormComponent} from './player-profile-login-form/player-profile-login-form.component';
import {ErrorType} from '../../../../model/error-type';
import {PlayerProfileService} from '../../service/player-profile.service';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {PlayerProfileServerSettings} from '../../model/player-profile-server-settings';
import {LoadingComponent} from '../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../components/generic/message/message.component';
import {Button} from 'primeng/button';
import {
  PlayerProfileFeaturesDialogComponent
} from './features/player-profile-features-dialog/player-profile-features-dialog.component';
import {DialogService} from 'primeng/dynamicdialog';
import {RoutingHelper} from '../../../../helper/routing.helper';
import {FrontendNotificationService} from '../../../frontend/service/frontend-notification.service';
import {Divider} from 'primeng/divider';

@Component({
  selector: 'app-player-profile-register',
  imports: [
    TranslatePipe,
    Panel,
    ReactiveFormsModule,
    PlayerProfileRegisterFormComponent,
    PlayerProfileLoginFormComponent,
    LoadingComponent,
    MessageComponent,
    Button,
    Divider
  ],
  templateUrl: './player-profile-register.component.html',
  styleUrl: './player-profile-register.component.scss'
})
export class PlayerProfileRegisterComponent implements OnInit
{
  public view = inject(ViewService);
  private router = inject(Router);
  private playerAuthenticationService = inject(PlayerAuthenticationService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private activatedRoute = inject(ActivatedRoute);
  private frontendNotificationService = inject(FrontendNotificationService);

  system = this.frontendNotificationService.system;
  registrationSuccess: boolean;
  fadeOutActive: boolean;
  forceRegistration: boolean;
  showRegistration = false;

  isLoading: boolean;
  errorMsg: ErrorType;
  settings: PlayerProfileServerSettings;

  ngOnInit(): void
  {
    this.initView();
    this.loadData();
  }

  initView(): void
  {
    this.forceRegistration = RoutingHelper.getUrlParamBool(this.activatedRoute, 'betatest');

    if (this.playerAuthenticationService.isAuthenticated())
      this.router.navigate([PLAYER_PREFIX_FULL + '/profile']).then(() => {});
  }

  public fadeOutLogin(): void
  {
    this.fadeOutActive = true;
    setTimeout(() => this.registrationSuccess = true, 200);
  }

  private loadData(): void
  {
    this.isLoading = true;
    this.errorMsg = undefined;
    this.settings = undefined;
    this.playerProfileService.loadSettings().subscribe({
      next: response =>
      {
        console.log('Einstellungen geladen', response);
        this.isLoading = false;
        this.settings = response;
      },
      error: error =>
      {
        this.isLoading = false;
        console.log('Fehler bei "loadData"', error);
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public openPlayerProfileFeatures(): void
  {
    PlayerProfileFeaturesDialogComponent.showDialog(this.dialogService, this.translate);
  }
}
